import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import { ErrorMessage, Input } from '#components/atoms/forms/index.ts';
import { ConfigOverrideHelpText } from '#components/patterns/config-overrides/help-text/ConfigOverrideHelpText.tsx';
import type { ConfigOverride } from '#dn-types/host.ts';
import { configOverridesDefaultValues } from '#schemas/config-override/config-overrides-default-values.ts';
import { schemas, type OverrideFormData } from '#screens/tags/form/config-overrides/config-forms/form-data.ts';
import { SingleConfigForm } from './parts/SingleConfigForm.tsx';

const OVERRIDE_KEY = 'definednet.dns.search_domains';
const DEFAULT_VALUES = {
  definednet: { dns: { search_domains: configOverridesDefaultValues.definednet.dns.search_domains } },
};
const schema = schemas[OVERRIDE_KEY];
type FormData = OverrideFormData[typeof OVERRIDE_KEY];

type Props = {
  defaultValues?: FormData;
  onSave: (overrides: ConfigOverride[]) => void;
};

export function DNSSearchDomains({ defaultValues, onSave }: Props) {
  const formContext = useForm({
    resolver: zodResolver(schema),
    defaultValues: defaultValues ?? DEFAULT_VALUES,
  });

  const error = formContext.formState.errors.definednet?.dns?.search_domains;

  return (
    <FormProvider {...formContext}>
      <SingleConfigForm overrideKey={OVERRIDE_KEY} onSave={onSave}>
        <ConfigOverrideHelpText configOverride={OVERRIDE_KEY} />
        <Input {...formContext.register(OVERRIDE_KEY)} className="width-100" hasError={Boolean(error)} />
        {error && <ErrorMessage>{error.message?.toString()}</ErrorMessage>}
      </SingleConfigForm>
    </FormProvider>
  );
}
